// extracted by mini-css-extract-plugin
module.exports = {"container":"Ex","productName":"Fx","modal":"Gx","dimensions":"Hx","recipientEmail":"Ix","lowStock":"Jx","recommendedFit":"Kx"};